module.exports = __webpack_public_path__ + "img/faq.3351c7b8.png";